export default "__VITE_PUBLIC_ASSET__f6c61b52__"